<template>
  <app-content>
    <pairing-detail-dialog
        v-if="detailItem"
        :item="detailItem.pairingDetails"
        @refreshDetailItem="refreshDetailItem"
    />
    <form action="#">
      <div class="inner">
        <p class="paging">
          <a
              class="btn btn_back"
              @click="$router.back()"
          >
            {{ translations.list }}
          </a>
        </p>
        <show-language-select
            :existingLanguagesIds="item.existingLanguagesIds"
            :selectedLanguageId="selectedLanguageId"
            :allLanguages="newItem"
            :isNewItem="newItem"
            @selectLanguage="onSelectLanguage"
            @addLanguage="createNewLanguageMutation"
        />
        <app-content-title v-if="!newItem" :title="item.name" :subTitle="appSubTitle" />
        <app-content-title v-if="newItem" :title="translations.newShow" />
      </div>
      <app-tabs
          :colsTabs="columnTabs"
          :shouldLoadFirstTab="newItem"
          :loadTab="params.tab"
          @appTabChanged="onAppTabChanged"
      >
        <div :title="translations.information">
          <sidebar
              :item="item"
              :link-name="linkName"
              :languageId="selectedLanguageId"
              :should-open-sidebar="!newItem"
              @moveAllExternalDataToShow="moveExternalData($event, false)"
              @moveExternalDataToShowEmptyFields="moveExternalData($event, true)"
              @imagesChanged="imagesChanged"
          />
          <content-main>
            <form ref="formDom" @submit.prevent="onFormSubmit" :disabled="dataPending">
              <information-details
                  ref="infoDetails"
                  :item="formItem"
                  :pending="dataPending"
                  :errors-prop="errors"
                  :isNewItem="newItem"
                  :parentName="$route.name"
                  :parentId="Number($route.params.id)"
                  :selectedShowLanguageId="selectedLanguageId"
                  @nameChange="linkName = $event"
              />
              <information-tags
                  ref="infoTags"
                  :formatLabels="formatLabels"
                  :contentLabels="contentLabels"
                  :countries="countries"
                  :pending="dataPending"
                  :errors-prop="errors"
                  @formatTagChanged="onFormatTagChanged"
                  @contentLabelsChanged="onContentLabelsChanged"
                  @contentCountriesChanged="onCountriesChanged"
              />
              <app-settings-buttons>
                <a
                    @click="$router.back()"
                >
                  {{ translations.list }}
                </a>
                <app-content-save-button
                    :disabled="dataPending"
                    @click="disallowBack"
                />
              </app-settings-buttons>
            </form>
          </content-main>
        </div>
        <div
            :title="imagesTitle"
            :data-disabled-title="translations.imagesSaveShowFirst"
            :data-disabled="!item || !item._id"
        >
          <images :parentName="$route.name" :parentId="Number($route.params.id)" />
        </div>
        <div
            :title="translations.pairingTemplates"
            :data-disabled-title="translations.pairingTemplatesSaveShowFirst"
            :data-disabled="!item || !item._id"
        >
          <templates />
        </div>
        <div
            :title="translations.episodes"
            :data-disabled-title="translations.episodesSaveShowFirst"
            :data-disabled="!item || !item._id"
        >
          <episodes :item="item" v-if="!pending"/>
        </div>
        <div
            :title="translations.broadcasts + ' (' + item.numberOfBroadcasts + ')'"
            :data-disabled-title="translations.broadcastsSaveShowFirst"
            :data-disabled="!item || !item._id"
        >
          <show-broadcasts :item="item" v-if="!pending" :countries="states" @openPairingDetails="selectDetailItem"/>
        </div>
        <div
          :title="translations.blackoutContentTemplates + ' (' + item.numberOfBlackoutContentTemplates + ')'"
          :data-disabled-title="translations.blackoutContentTemplatesShowFirst"
          :data-disabled="!item || !item._id"
        >
            <blackout-content-templates v-if="!pending" :parentId="Number($route.params.id)" />
        </div>
      </app-tabs>
    </form>
  </app-content>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getCommonFormSubmit } from 'utils/form'
import Sidebar from 'components/Show/MainSidebar/index'
import ContentRoot from 'components/Show/Common/ContentRoot'
import ContentMain from 'components/Show/Common/ContentMain'
import InformationDetails from 'components/Show/Common/InformationDetails'
import InformationTags from 'components/Show/Common/InformationTags'
import Episodes from 'components/Show/Common/Episodes'
import Images from 'components/Show/Common/Images'
import ShowLanguageSelect from 'components/Show/Common/ShowLanguageSelect'
import Templates from 'components/Show/Common/Templates'
import BlackoutContentTemplates from "components/Show/Common/BlackoutContentTemplates.vue";
import appTitleMixin from 'mixins/appTitleMixin'
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import { setLoadingMessage, showErrorWithTimeout } from 'utils/form'
import { SHOW_TEMPLATE } from 'constants/showTemplate'
import ShowBroadcasts from '../../components/Show/Common/Broadcasts'
import PairingDetailDialog from '@/components/PairingDetailDialog'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Show'
})

export default {
  name: 'show',
  mixins: [itemDetailMixin, appTitleMixin()],
  components: {
    PairingDetailDialog,
    ShowBroadcasts,
    Sidebar,
    ContentRoot,
    ContentMain,
    InformationDetails,
    InformationTags,
    Episodes,
    Images,
    ShowLanguageSelect,
    Templates,
    BlackoutContentTemplates,
  },
  created() {
    if (this.newItem) {
      this.selectedLanguageId = this.currentLanguageId
    }

    this.getLabelsForCurrentLanguage()
    this.getCountriesForCurrentLanguage()
    this.params.tab = 0
  },
  data() {
    return {
      columnTabs: [
        0,
        3
      ],
      detailItem: null,
      imagesUploading: false,
      linkName: null,
      selectedLanguageId: null,
      emptyShow: { ...SHOW_TEMPLATE },
      setterContentLabels: null,
      setterCountries: null,
      changedImages: []
    }
  },
  computed: {
    ...mapState({
      labels: state => state.labels.labels,
      states: state => state.countries.countries,
      labelsPending: state => state.labels.pending.labels,
      currentLanguageId: state => state.uiLanguages.currentLanguageId,
      images: state => state.images.images,
      broadcastImages: state => state.images.broadcastImages
    }),
    imagesTitle() {
      return this.translations.images + ' (' + this.images.length + ', ' + this.broadcastImages.length + ')'
    },
    translations() {
      return {
        newShow: this.$gettext('Nový pořad'),
        information: this.$gettext('Informace'),
        list: this.$gettext('Seznam'),
        images: this.$gettext('Obrázky'),
        imagesSaveShowFirst: this.$gettext('Obrázky (nutné uložit pořad)'),
        pairingTemplates: this.$gettext('Párovací šablony'),
        pairingTemplatesSaveShowFirst: this.$gettext('Párovací šablony (nutné uložit pořad)'),
        episodes: this.$gettext('Epizody'),
        episodesSaveShowFirst: this.$gettext('Epizody (nutné uložit pořad)'),
        broadcasts: this.$gettext('Vysílání'),
        broadcastsSaveShowFirst: this.$gettext('Vysílání (nutné uložit pořad)'),
        blackoutContentTemplates: this.$gettext('Blokovací šablony'),
        blackoutContentTemplatesShowFirst: this.$gettext('Blokovací šablony (nutné uložit pořad)'),
      }
    },
    formatLabels() {
      if (!this.labels) {
        return {}
      }
      return this.labels
        .filter(v => v.type === 'LABEL_TYPE_FORMAT')
        .reduce((obj, v) => {
          obj[v.labelName] = {
            _id: v._id,
            name: v.labelName,
            checked: this.item.formatLabelId === v._id
          }
          return obj
        }, {})
    },
    countries() {
      if (this.setterCountries) {
        const countries = this.setterCountries
        this.setterCountries = null
        return countries
      }

      if (!this.states) {
        return []
      }

      const countries = this.states
      countries.forEach(item => {
        item['name'] = item['countryName']
        item['checked'] = (this.item.countryIds && this.item.countryIds.includes(item._id)) || false
      })

      return countries
    },
    contentLabels() {
      if (this.setterContentLabels) {
        const contentLabels = this.setterContentLabels
        this.setterContentLabels = null
        return contentLabels
      }

      if (!this.labels) {
        return []
      }

      const contentLabels = this.labels.filter(v => v.type === 'LABEL_TYPE_CONTENT')
      contentLabels.forEach(item => {
        item['name'] = item['labelName']
        item['checked'] = (this.item.contentLabelIds && this.item.contentLabelIds.includes(item._id)) || false
      })

      return contentLabels
    },
    appSubTitle() {
      let str = ''
      if (this.item.originalName) {
        str += ` | ${this.item.originalName}`
      }
      return str
    },
    currentTitle() {
      return [
        { name: this.$gettext('Pořady'), link: { name: 'shows' } },
        this.item.name || this.item.originalName || this.item.firstTranslationName || 'Nový pořad'
      ]
    },
    dataPending() {
      return this.pending || this.labelsPending || this.imagesUploading
    }
  },
  methods: {
    ...mapActions([
      'getLabels',
      'getLanguages',
      'getShow',
      'getCountries',
      'getImages',
      'getBroadcastImages'
    ]),
    imagesChanged(images) {
      this.changedImages = images
    },
    selectDetailItem(item) {
      this.detailItem = item
    },
    refreshDetailItem() {
      this.detailItem = null
    },
    onContentLabelsChanged(contentLabels) {
      this.setterContentLabels = contentLabels
    },
    onCountriesChanged(countries) {
      this.setterCountries = countries
    },
    getLabelsForCurrentLanguage() {
      this.getLabels({
        params: {
          idLanguage: this.currentLanguageId,
          order: 'labelNames'
        }
      })
    },
    getCountriesForCurrentLanguage() {
      this.getCountries({
        params: {
          idLanguage: this.currentLanguageId,
          order: '-weight'
        }
      })
    },
    onFormatTagChanged(id) {
      if (id !== null) {
        this.errors.remove('tagFormatId')
      }
    },
    onCountryChanged(id) {
      if (id !== null) {
        this.errors.remove('countryId')
      }
    },
    onSelectLanguage(idLanguage) {
      this.selectedLanguageId = idLanguage
      if (!this.newItem) {
        this.getShow({
          params: {
            id: this.itemId,
            idLanguage: idLanguage
          }
        })
      }
    },
    updateSelectedLanguageId() {
      this.selectedLanguageId = this.item.selectedLanguageId
    },
    createNewLanguageMutation(addedLanguage) {
      this.selectedLanguageId = addedLanguage._id
      this.$refs.infoDetails.createNewLanguageMutation()
    },
    async onFormSubmit(e) {
      if (this.selectedLanguageId === null) {
        showErrorWithTimeout(this, this.$gettext('Nejprve přidejte jazyk.'))

        return
      }

      this.errors.clear()

      const commonFormSubmit = getCommonFormSubmit('Show')
      const response = await commonFormSubmit(this, e, {
        idLanguage: this.selectedLanguageId,
        contentLabelIds: this.contentLabels.filter(v => v.checked === true).map(v => v._id),
        countryIds: this.countries.filter(v => v.checked === true).map(v => v._id),
        importImages: this.changedImages
      }).catch(err => err.response)

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }
    },
    setImagesUploading(uploading) {
      this.imagesUploading = uploading
      setLoadingMessage(this, uploading ? 'Nahrávání obrázků...' : null)
    },
    moveExternalData(data, onlyToEmpty) {
      if (this.selectedLanguageId !== null) {
        const sourceData = this.$refs.infoDetails.getShowData()
        const externalShowData = data.externalShowData
        const sourceDataToReplace = {}

        if (!onlyToEmpty) {
          sourceDataToReplace.csfdId = ''
          sourceDataToReplace.tmdbId = ''
          sourceDataToReplace.imdbId = ''
          sourceDataToReplace.name = ''
          sourceDataToReplace.originalName = ''
          sourceDataToReplace.rating = ''
          sourceDataToReplace.directors = ''
          sourceDataToReplace.cast = ''
          sourceDataToReplace.description = ''
          sourceDataToReplace.yearStart = ''
          sourceDataToReplace.yearEnd = ''
          sourceDataToReplace.duration = ''
          sourceDataToReplace.originalGenre = ''
          sourceDataToReplace.youtubeLink = ''
          sourceDataToReplace.leadParagraph = ''
          sourceDataToReplace.dataSource = ''
          sourceDataToReplace.isPeriodic = null
          this.$refs.infoTags.resetTagFormat()
          this.$refs.infoTags.removeAllContentLabels()
          this.$refs.infoTags.removeAllCountries()
        }

        if (data.id && data.type) {
          if (data.type == 'csfd') {
            sourceDataToReplace.csfdId = data.id
          } else if (data.type == 'tmdb') {
            sourceDataToReplace.tmdbId = data.id
          }
        }

        if (data.periodic !== null) {
          sourceDataToReplace.isPeriodic = data.periodic
        }

        if (data.durationInMinutes) {
          sourceDataToReplace.duration = data.durationInMinutes
        }

        Object.keys(externalShowData).forEach(fieldName => {
          const externalShowDataField = externalShowData[fieldName]

          if (!onlyToEmpty || !sourceData[fieldName]) {
            switch (fieldName) {
              case 'name':
              case 'originalName':
              case 'rating':
              case 'directors':
              case 'cast':
              case 'description':
                sourceDataToReplace[fieldName] = externalShowDataField.value
                break
              case 'year':
                if (!onlyToEmpty || !sourceData.yearStart) {
                  sourceDataToReplace.yearStart = externalShowDataField.value
                }
                break
            }
          }
        })

        this.$refs.infoDetails.copyFromExternalData(sourceDataToReplace)

        if (
          data.formatLabelId &&
          (!onlyToEmpty || this.$refs.infoTags.isTagFormatIdEmpty())
        ) {
          this.$refs.infoTags.setTagFormatId(data.formatLabelId)
        } else if (!onlyToEmpty) {
          this.$refs.infoTags.resetTagFormat()
        }

        if (
          data.contentLabelIds.length > 0 &&
          (!onlyToEmpty || this.$refs.infoTags.isContentLabelEmpty())
        ) {
          this.$refs.infoTags.removeAllContentLabels()
          data.contentLabelIds.forEach(contentLabelId => {
            this.$refs.infoTags.contentLabelSelected(contentLabelId)
          })
        } else if (!onlyToEmpty && data.contentLabelIds.length == 0) {
          this.$refs.infoTags.removeAllContentLabels()
        }

        if (
          data.countryIds.length > 0 &&
          (!onlyToEmpty || this.$refs.infoTags.isCountryEmpty())
        ) {
          this.$refs.infoTags.removeAllCountries()
          data.countryIds.forEach(countryId => {
            this.$refs.infoTags.countrySelected(countryId)
          })
        } else if (!onlyToEmpty && data.countryIds.length == 0) {
          this.$refs.infoTags.removeAllCountries()
        }
      } else {
        showErrorWithTimeout(this, this.$gettext('Nejprve přidejte jazyk.'))
      }
    },
    loadImages() {
      this.getImages({
        params: {
          parentName: 'show',
          parentId: this.item._id
        }
      })
      this.getBroadcastImages({
        params: {
          parentId: this.item._id
        }
      })
    }
  },
  watch: {
    currentLanguageId() {
      this.getLabelsForCurrentLanguage()
      this.getCountriesForCurrentLanguage()
    },
    item() {
      this.updateSelectedLanguageId()
      if (this.item) {
        this.loadImages()
      }
    }
  }
}
</script>
